import { Component, Input } from '@angular/core';

import { Procedimentos } from '../../base/vo/procedimentos';


@Component({
  selector: 'app-modal-finalizar',
  templateUrl: './modal-finalizar.component.html',
  styleUrls: ['./modal-finalizar.component.scss']
})
export class ModalFinalizarComponent {

  @Input() confirmFunc: Function;
  @Input() idGto: number;
  @Input() loading = false;
  @Input() procedimentos: Procedimentos[];

  public displayModal = false;
  public displayModalSuccess = false;
  public currentDate = new Date();

  public openDialog() {
    this.displayModal = true;
    this.procedimentos = this.procedimentos.filter(x => x.dataRealizacao);
  }

  public closeDialog() {
    this.displayModal = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gto-finalizar/modal-finalizar/modal-finalizar.component.ts